export default function setTitleErrorAction(titleError) {
    return {
        type: 'SET_TITLE_ERR',
        payload: titleError
    }
}